module.exports = __webpack_public_path__ + "img/section5_bgEn.be78cf8c.png";